import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import GenericTable from '../../components/GenericTable/GenericTable';
import SearchBar from '../../components/SearchBar/SearchBar'; 
import {  FaTimesCircle, FaPen } from 'react-icons/fa';
import Pagination from '../../components/Pagination/Pagination';
import DomainForm from '../../components/DomainForm/DomainForm';
import Cookies from 'js-cookie';
import MultiValueInput from '../../components/MultiValue/MultiValue'


function PoolPage() {
    const [poolDomains, setPoolDomains] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [domainsPerPage] = useState(25); // Set how many domains per page
    const { poolName } = useParams(); 

    const [isEditingPoolName, setIsEditingPoolName] = useState(false);
    const [editedPoolName, setEditedPoolName] = useState(poolName); 

    const navigate = useNavigate(); 


    useEffect(() => {
        const fetchPoolDomains= async () => {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/pool/domain?pool=${poolName}`, {
                method: "GET",
                credentials: "include"
            });
            if (response.status === 401) {
                Cookies.remove('session-id');
                navigate('/login');
            }
            const body = await response.json();
            console.log(body.data);
            setPoolDomains(body.data);

        };
        fetchPoolDomains();

    }, []);

    const handleDeleteDomain = async (hostname) => {
        console.log(`delete ${hostname}`);

        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/domain?hostname=${hostname}`, {
            method: "DELETE",
            credentials: "include"
        })
        if (response.status === 401) {
            Cookies.remove('session-id');
            navigate('/login');
        }

        if (response.ok) {
            setPoolDomains(prevDomains => 
                prevDomains.filter(domain => domain.hostname !== hostname)
            );
        }
    }


    const headers = ['Hostname', ''];
    const rows = poolDomains.map(domain => ({
        hostname: domain.hostname,
        action: (
            <div className="flex items-center justify-center">
                <FaTimesCircle className="text-red-500" onClick={() => handleDeleteDomain(domain.hostname)} /> 
            </div>
        )
    }));

    const filteredRows = rows.filter(row =>
        (row.hostname && row.hostname.toLowerCase().includes(searchQuery))
    );

    // Pagination logic
    const totalPages = Math.ceil(filteredRows.length / domainsPerPage);
    const startIndex = (currentPage - 1) * domainsPerPage;
    const currentRows = filteredRows.slice(startIndex, startIndex + domainsPerPage);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleAddDomains = async (formData) => {
        const hostnames = formData;
        console.log(formData);
        // ? formData
        //     .split('\n')
        //     .map(hostname => hostname.trim())
        //     .filter(hostname => hostname)  // Remove empty hostnames
        //     .map(hostname => hostname.replace(/\s+/g, ''))  // Remove space characters only
        //     .filter(hostname => !poolDomains.some(domain => domain.hostname === hostname))
        // : [];
        if (hostnames.length === 0) {
            return;
        }

        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/domain?pool=${poolName}`, {
            method: 'POST',
            credentials: "include",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(hostnames)
        });
        if (response.status === 401) {
            Cookies.remove('session-id');
            navigate('/login');
        }
        if (response.ok) {
            const body = await response.json();
            console.log('body.data', body.data);
            console.log('pool domains', poolDomains);
            setPoolDomains(prevHostnames => [...prevHostnames, ...body.data]);
        }
    };


    const handleEditPoolName = () => {
        setIsEditingPoolName(true);
    };


    const handleSavePoolName = async () => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/pool`, {
            method: 'PUT',
            credentials: "include",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ old: poolName, new: editedPoolName })
        });
        if (response.status === 401) {
            Cookies.remove('session-id');
            navigate('/login');
        }
        if (response.ok) {
            setIsEditingPoolName(false);
            navigate(`/pool/${editedPoolName}`);
        }
    };


    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSavePoolName();  // Trigger save on Enter key press
        }
    };


    return (
        <div className='p-4'>  
            <div className="max-w-sm mx-auto">
                <div className='min-w-64'>
                    <h4 className="px-2 text-md font-semibold">Overview</h4>
                    <div className="px-2 flex items-center justify-between gap-2 mb-6">
                        {isEditingPoolName ? (
                            <input
                                type="text"
                                value={editedPoolName}
                                onChange={(e) => setEditedPoolName(e.target.value)}
                                onBlur={handleSavePoolName} // Save when input loses focus
                                onKeyDown={handleKeyPress}   
                                className="text-2xl w-full font-bold border-b border-gray-400 focus:outline-none"
                            />
                        ) : (
                            <h2 className="text-2xl font-bold">
                                {editedPoolName}
                            </h2>
                        )}
                        <FaPen
                            className="text-gray-500 cursor-pointer"
                            onClick={handleEditPoolName}
                        />
                    </div>
                    <div className="max-w-md my-5 mx-auto">
                        <MultiValueInput onSubmit={handleAddDomains} />
                    </div>
                </div>
                
                <div className=''>
                    {currentRows.length === 0 ? (
                        <p className="my-10 text-xl font-semibold text-gray-500 text-center">No domains found.</p>
                    ) : (
                        <div>
                            <div className="w-full max-w-xl my-5 mx-auto">
                                <SearchBar placeholder="Search by hostname.." onSearch={setSearchQuery} />
                            </div>
                            <GenericTable headers={headers} data={currentRows} className="w-full" groupName={`${poolName}-domains`} />
                            <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default PoolPage;